module.exports = "<svg viewBox=\"0 0 146.1 167\"><path fill=\"#1D1D1B\" d=\"M59.7 167L0 46.4l14.3-7.1 46.1 93L132 0l14.1 7.6z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/check.svg
// module id = 232
// module chunks = 1